var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10 max-w-6xl mx-auto" }, [
    _c(
      "ul",
      {
        staticClass:
          "grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
        attrs: { role: "list" }
      },
      _vm._l(_vm.integrations, function(integration, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass:
              "col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200",
            on: {
              click: function($event) {
                return _vm.gotoIntegration(integration)
              }
            }
          },
          [
            _c("div", { staticClass: "flex-1 flex flex-col p-8" }, [
              _c("img", {
                staticClass: "w-32 h-32 flex-shrink-0 mx-auto object-contain",
                attrs: {
                  src: require("../../assets/integrations/loox.png"),
                  alt: ""
                }
              }),
              _c(
                "h3",
                { staticClass: "mt-6 text-gray-900 text-sm font-medium" },
                [_vm._v(" " + _vm._s(integration.name) + " ")]
              ),
              _c(
                "dl",
                { staticClass: "mt-1 flex-grow flex flex-col justify-between" },
                [
                  _c("dd", { staticClass: "text-gray-500 text-sm" }, [
                    _vm._v(_vm._s(integration.category))
                  ])
                ]
              )
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }